import React, { useContext, useEffect } from 'react';
import { Routes, Route, useNavigate, useLocation, useSearchParams } from "react-router-dom";
import CheckInDetail from './CheckInDetail'
import CheckInIdentify from './CheckInIdentify';
import CheckInIdentifyLanding from './CheckInIdentifyLanding';
import CheckInEdit from './CheckInEdit';
import { CheckInContext } from '../context/checkin';
import { UserContext } from '../context/user';
import Welcome from './Welcome';
import Chat from './Chat';
import CheckInPassenger from './CheckIn/Passenger';
import Camera from './Camera';
import Status from "./Status";
import CheckInDetailNew from './CheckinDetailNew';
import { useParams } from 'react-router';
import WelcomeKiosk from './Kiosk/Welcome/Main';

const CheckIn = () => {
    const navigate = useNavigate();
    const { pathname, search } = useLocation();
    // const [ searchParams ] = useSearchParams();
    const { data: checkIn, webCheckInDone } = useContext(CheckInContext)
    const { inStay, initied } = useContext(UserContext)

    const { id, redirect } = useParams();

    useEffect(() => {
        // Google Analytics
        // ga('send', 'pageview');
        // FIXME: Esto ocurre todo el tiempo y la idea es que ocurra solo cuando entra por URL

        if (pathname.indexOf('/r/') !== -1) {
            let fullpath = pathname + search;
            // OLD REDIRECT
            // http://localhost:3001/dev-matias/r/REDKCIDK-1?redirect=pay/sd
            if (redirect) {
                fullpath = fullpath.replace(`/${redirect}`, '');
                // fullpath = `${fullpath}?redirect=${redirect.replace(`_`, '/')}`;
                fullpath = `${fullpath}?redirect=${redirect.replace(/__/g, '/')}`;
            }
            navigate(fullpath.replace('/r/', '/checkin/identify/'), { replace: true })
            return;
        }
        
        if (pathname.indexOf('/e/') !== -1) {
            const fullpath = pathname + search;
            navigate(fullpath.replace('/e/', '/checkin/identify/e_'), { replace: true })
            return;
        }

        if (pathname.indexOf('checkin/identify') === -1 && search.indexOf('redirected') === -1) {
            if (!checkIn?.id) {
                navigate('identify', { replace: true })
                return;
            }

            if (pathname.indexOf('checkin/welcome') === -1 && pathname.indexOf('checkin/edit') === -1 && pathname.indexOf('checkin/messages') === -1) {
                if (inStay && !initied) {
                    navigate('welcome', { replace: true })
                    return;
                } else {
                    navigate('status', { replace: true })
                    return;
                }
            }


            // --- esto estaba ---

            // if (inStay) {
            //     if (webCheckInDone) {
            //         if (pathname.indexOf('checkin') !== -1) {
            //             if (!initied) {
            //                 navigate('welcome', { replace: true })
            //             } 
            //             // else {
            //             //     navigate('../services', { replace: true })
            //             // }
            //         }
            //     }
            // } else {
            //     console.log('25oct - bbb')
            //     if (!checkIn?.id) {
            //         navigate('identify', { replace: true })
            //     }
            //     // if (webCheckInDone) {
            //     //     console.log('17sep - pathname', pathname)
            //     //     console.log('17sep - search', search)
            //     //     if (pathname.indexOf('checkin/messages') === -1 && pathname.indexOf('checkin/passenger/') === -1 && search !== '?edit=true') {    
            //     //         navigate('../status', { replace: true })
            //     //     }
            //     // }
            //     navigate('../status', { replace: true })
            // }


            // --- esto estaba ---


            // else {
            //     console.log('0206 - aaaa')
            //     return;
            //     if (pathname.indexOf('identify') === -1) {
            //         console.log('0206 - bbb')
            //         if (!checkIn?.id) {
            //             navigate('identify', { replace: true })
            //         }
            //     }
            // }
        } else {
            // const redirect = searchParams.get('redirect');
            // if (redirect) {
            //     setTimeout(() => {
            //         navigate(`../${redirect}`, { replace: true })
            //     }, 2500);
            // } else 


            // if (inStay && initied) {
            //     navigate('../services', { replace: true })
            // }
        }

    }, [checkIn, inStay, initied, pathname]);

    return (<Routes>
        {/* <Route index element={<CheckInDetail />} /> */}
        <Route index element={<div className="text-center mt-4 mb-4" style={{ opacity: 0.3 }}>
            <div className="spinner-border" role="status"></div>
        </div>} />
        <Route exact path={`identify/landing`} element={<CheckInIdentifyLanding />} />
        <Route path={`identify/*`} element={<CheckInIdentify />} />
        {/* <Route exact path={`edit`} element={<CheckInEdit />} /> */}
        <Route exact path={`edit`} element={<CheckInDetail />} />
        <Route exact path={`edit/passenger/:idx/*`}>
            <Route index element={<CheckInPassenger />} />
            <Route exact path={`camera/:imageCode`} element={<Camera />} />
        </Route>
        <Route exact path={`edit/linked_checkin_passenger/:linked_checkin_idx/:idx/*`}>
            <Route index element={<CheckInPassenger />} />
            <Route exact path={`camera/:imageCode`} element={<Camera />} />
        </Route>

        <Route exact path={`edit-new`} element={<CheckInDetailNew />} />
        <Route exact path={`edit-new/passenger/:idx/*`}>
            <Route index element={<CheckInPassenger />} />
            <Route exact path={`camera/:imageCode`} element={<Camera />} />
        </Route>
        <Route exact path={`edit-new/linked_checkin_passenger/:linked_checkin_idx/:idx/*`}>
            <Route index element={<CheckInPassenger />} />
            <Route exact path={`camera/:imageCode`} element={<Camera />} />
        </Route>

        <Route exact path={`messages`} element={<Chat entity={'checkIn'} />} />
        <Route exact path={`status`} element={<Status />} />
        <Route exact path={`welcome`} element={<Welcome />} />
        <Route exact path={`kiosk/welcome-kiosk`} element={<WelcomeKiosk />} />
        {/* <Route path={`/${hotel.code}/checkin/*`} 
                    render={({ location }) => {
                        const welcomePath = `/${hotel?.code}/checkin/welcome`;
                        const isLocationIdentify = location.pathname.indexOf(`/${hotel.code}/checkin/identify`) !== -1;
                        const isLocationWelcome = location.pathname.indexOf(welcomePath) !== -1;

                        if (inStay && !initied && !isLocationIdentify && !isLocationWelcome) {
                            return <Navigate to={welcomePath} />
                        }
                        // if (location.pathname.indexOf(pathIdentify) === -1) {
                        //     return <Redirect to={pathIdentify} />
                        // }
                        // if (checkIn?.id) {
                        //     if (location.pathname !== pathWelcome && inStay && !initied) {
                        //         // return <Welcome />
                        //         return <Redirect to={pathWelcome} />
                        //     }
                        // }
                        return (<Routes>
                            <Route path={`welcome`} element={<Welcome />} />
                            <Route path={`/${hotel.code}/checkin/identify`} element={<CheckInIdentify />} />
                            <Route path={`edit`} element={<CheckInEdit />} />
                            <Route exact path={`/`} element={<CheckInDetail />} />                                    
                        </Routes>)
                    }}>
                </Route> */}
    </Routes>)
}

export default CheckIn;